import { toast } from "react-toastify";

// COMMON Import
import SecondaryRightIconSmallButton from "../CommonButtons/SecondaryRightIconSmallButton";

// SVGCOMPONENT Import
import SVGComponent from "../SVGComponent";
// Suggestions of props for component while using the components -------------------------------------
/**

* @typedef {Object} BtnProps
* @property {string} btnText - Text to show inside the button
* @property {Function} handleFunction - Callback function triggered on button click
* @property {string?} icon - URL for the icon displayed on the right side of the button
* @property {string?} enabledBgColor - Background color for the button (CSS variable)
* @property {string?} enabledTextColor - Text color for the button (CSS variable)
* @property {boolean?} isDisabled - Toggle to disable button interactions
*/

/**

* @param {Object} props
* @param {string} props.text - The message content to be displayed in the toast
* @param {string} props.icon - URL of the SVG icon to display alongside the text
* @param {string?} props.iconColor - CSS variable for the SVG icon color
* @param {string} props.variant - CSS variable for the background color (e.g., var(--error), var(--success))
* @param {boolean} props.buttonNeeded - Toggle to show/hide the secondary action button
* @param {BtnProps} [props.btnProps] - Configuration for the SecondaryRightIconSmallButton component
* * @returns {React.ReactText | undefined}
*/
const CommonToast = ({
  text,
  icon,
  iconColor,
  variant,
  buttonNeeded,
  btnProps,
}) => {
  if (!text) {
    return;
  }
  return toast(
    <div
      style={{ backgroundColor: variant }}
      className={`flex flex-col w-toast-width ${buttonNeeded ? "gap-y-gap-sm" : ""} `}
    >
      <div className="flex gap-x-gap-sm items-center">
        <SVGComponent
          url={icon}
          color={iconColor}
          height="var(--icon-md)"
          width="var(--icon-md)"
        />
        <p className="text-text-primary text-font-sm">{text}</p>
      </div>
      {buttonNeeded ? (
        <div
          style={{ display: buttonNeeded ? "flex" : "none" }}
          className="w-auto"
        >
          {buttonNeeded ? (
            <SecondaryRightIconSmallButton {...btnProps} />
          ) : null}
        </div>
      ) : null}
    </div>,
    {
      position: "bottom-right",
      hideProgressBar: false,
      autoClose: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      fontSize: "var(--font-sm)",
      style: {
        width: "var(--width-full)",
        borderRadius: "var(--border-radius-sm)",
        backgroundColor: variant,
        color: "var(--text-primary)",
        zIndex: "var(--max-zindex)",
      },
    },
  );
};

export default CommonToast;
